import { useEffect } from "react";
import { Crisp } from "crisp-sdk-web";

export const CrispChat = () => {
  useEffect(() => {
    Crisp.configure("fde6b02b-2a1f-495e-af8d-1895e16498b8");
  }, []);
  return null;
};